import { Button, ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  label: string
  startIcon?: any
}

function RoundClose(props: Props) {
  const { label, startIcon, ...buttonProps } = props
  return (
    <Button
      startIcon={startIcon ? startIcon : null}
      variant='outlined'
      {...props}
      sx={{
        borderRadius: '24px',
        borderColor: 'grey.50',
        textTransform: 'none',
        width: '100px',
        height: '32px',
        fontSize: '14px',
        ...props.sx,
      }}
    >
      {label}
    </Button>
  )
}
export default RoundClose
